import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { get } from 'lodash'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import { FilterContacts } from 'containers/filters'
import { Modal } from 'containers/misc'
import { ContactCreate } from 'containers/forms/contacts'
import { Table, Data } from 'components/layout/Table'
import { Button, SystemRights, Status } from 'components/misc'
import { meta } from 'helpers/decorators'
import { apiContacts, apiConfiguration } from 'helpers/decorators/api'
import { contacts as contactsLayout } from 'constants/layout'
import { modal } from 'redux/modules/app'
import config from 'config'
import { CONFIGURATION_KEYS } from '../../../constants/enums'

const enhance = compose(
  meta({
    title: 'Contacts',
    intlKey: 'pageTitle.contacts',
    noOverride: true
  }),
  apiContacts({
    list: true,
    clearDetail: true
  }),
  apiConfiguration({
    getValues: [
      CONFIGURATION_KEYS.awardStaffRegistrationEmailAddress2.id,
      CONFIGURATION_KEYS.awardStaffRegistrationPhone.id,
      CONFIGURATION_KEYS.awardStaffRegistrationTitle.id,
      CONFIGURATION_KEYS.awardStaffRegistrationMiddleName.id,
      CONFIGURATION_KEYS.awardStaffRegistrationAddressLine2.id,
      CONFIGURATION_KEYS.awardStaffRegistrationAddressLine1.id,
      CONFIGURATION_KEYS.awardStaffRegistrationAddressCity.id,
      CONFIGURATION_KEYS.awardStaffRegistrationAddressZipCode.id,
      CONFIGURATION_KEYS.awardStaffRegistrationAddressRegion.id,
      CONFIGURATION_KEYS.awardStaffRegistrationAddressCountry.id,
      CONFIGURATION_KEYS.awardStaffRegistrationRole.id,
      CONFIGURATION_KEYS.awardStaffRegistrationGender.id
    ]
  }),
  connect(null, { modal })
)

class ContactsList extends Component {
  static propTypes = {
    contacts: PropTypes.object.isRequired,
    modal: PropTypes.func.isRequired,
    configuration: PropTypes.object.isRequired,
    setOrganizationContactsParams: PropTypes.func.isRequired
  }

  render() {
    const {
      contacts: { loading, list, offset, limit, pages, sort },
      setOrganizationContactsParams,
      configuration
    } = this.props

    return (
      <div>
        <div className="text--right base-margin--bottom">
          <Button
            intlKey="button.new_contact"
            onClick={() => this.props.modal('modal-create-contact')}
          >
            New Contact
          </Button>
        </div>
        <FilterContacts />
        <Table
          loading={loading}
          length={list.length}
          offset={offset}
          limit={limit}
          pages={pages}
          sort={sort}
          ths={contactsLayout.tableHeaders}
          setParams={setOrganizationContactsParams}
        >
          <Data>
            {list.map(contact => (
              <tr key={get(contact, 'id')}>
                <td>
                  <Link
                    to={`${config.publicPath}/organizations/${get(contact, 'organization.id')}/contacts/${get(contact, 'id')}`}
                  >
                    {get(contact, 'globalId') || get(contact, 'id')}
                  </Link>
                </td>
                <td>
                  {get(contact, 'firstName') ||
                    get(contact, 'person.firstName')}
                </td>
                <td>
                  {get(contact, 'lastName') || get(contact, 'person.lastName')}
                </td>
                <td>{get(contact, 'email') || get(contact, 'person.email')}</td>
                <td>
                  <SystemRights data={contact} configuration={configuration} />
                </td>
                <td>
                  <Status state={get(contact, 'person.personState')} />
                </td>
              </tr>
            ))}
          </Data>
        </Table>
        <Modal id="modal-create-contact" customActions fluid>
          <ContactCreate onClose={() => this.props.modal(null)} isOrganizationContact={true} configuration={configuration} />
        </Modal>
      </div>
    )
  }
}

export default enhance(ContactsList)
